// extracted by mini-css-extract-plugin
export default {"hasCustomLink":"TxcM4HF1THjB7Q_fpKEM","container":"xKXMdwzhs1vKWYDfNnei"};